class AmountService {
	getAmount = (amount: number | string | undefined) => {
		if (!amount) {
			return 0;
		}
		if (typeof amount === 'string') {
			const isNumeric = !isNaN(parseFloat(amount));
			if (!isNumeric) {
				return 0;
			}
			return parseFloat(amount);
		}
		return amount;
	};
}

export default new AmountService();
